module.exports = __webpack_public_path__ + "media/pl_pl_s6_Zuzanna.3541a0fe.mp3";